import RootStore from './RootStore';
import { IResult } from '../global.d';
import { observable, action, computed } from 'mobx';

import luckyApi from '../actions/lucky';
import stat from '../utils/stat';

export interface ILuckyOption {
  luck_id: number;
  name: string;
  desc: string;
  thumb: string;
  id: number;
  count_num: number;
}

export interface ILucky {
  id: number;
  gallery_id: string | number;
  title: string;
  begin_at: string;
  end_at: string;
  type: string;
  status: number;
  desc?: string;
  max_join_number: number;
  goods_detail?: ILuckyOption[];
}

export interface IUserLuckyOne {
  id: number;
  luck_id: number;
  goods_id: number;
  mobile?: string;
  status: number;
  user_open_id: string;
  address?: string;
  name?: string;
}

export interface IUserLucky {
  max_join_number: number;
  user_join_hit: number;
  luck_list: IUserLuckyOne[];
}

interface IUserLuckyMap {
  [key: string]: IUserLucky;
}

interface ILuckyMap {
  [key: string]: ILucky;
}

export default class LuckyStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable list = {} as ILuckyMap;
  @observable luckyed = {} as IUserLuckyMap;

  @action updateData = (id: string | number, data: any) => {
    let target = this.list[String(id)];
    if (target) {
      this.list[String(id)] = {
        ...target,
        ...data
      };
    }
  };

  checkLucky = (id: string | number, force?: boolean) => {
    return luckyApi.one(id, force).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          if (data && data.id) {
            this.list = {
              ...this.list,
              [String(data.id)]: data
            };
          }

          return res.data;
        }

        return null;
      })
    );
  };

  checkUserLucky = (id: string | number) => {
    if (!id) {
      return;
    }
    return luckyApi.lucktome(id).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          this.luckyed = {
            ...this.luckyed,
            [String(id)]: data
          };

          return res.data;
        }

        return null;
      })
    );
  };

  getLucky = (id: number) => {
    return this.list[String(id)];
  };

  getUserLuckyed = (id: string | number) => {
    return this.luckyed[String(id)];
  };

  doRecord = (record_id: string | number, update: any) => {
    stat.event('lucky_got');
    return luckyApi.verify(record_id, update);
  };

  getLuckResult = (luck_id: string | number, page: number = 1) => {
    return luckyApi.luckresult(luck_id, page);
  };

  @action addRecord = (luck_id: string | number) => {
    stat.event('lucky');

    // 减少一次抽奖
    let voted = this.luckyed[String(luck_id)];
    if (voted) {
      if (voted.user_join_hit >= voted.max_join_number) {
        // 没有抽奖次数了
        return new Promise<IResult>(resolve => {
          resolve({
            code: 201103
          });
        });
      } else {
        voted.user_join_hit = Math.min(
          voted.max_join_number,
          voted.user_join_hit + 1
        );
      }
    }

    // return new Promise<IResult>(resolve=>{
    //   resolve({
    //     code:200,
    //     data:{
    //       created_at: "2021-06-08 14:22:40",
    //       goods_id: "21",
    //       id: 275,
    //       luck_id: 5,
    //       updated_at: "2021-06-08 14:22:40",
    //       user_open_id: "ov02B0_ISce47a0M-ZZKNorctIhY"
    //     }
    //   });
    // })

    return luckyApi.addRecord(luck_id);
  };
}
